export const maskPhoneNumber = (
  phone: string,
  visibleDigits: number = 4,
): string => {
  if (!phone) return '';

  const clean = phone.replace(/\s+/g, '');

  const safeVisibleDigits = Math.max(0, visibleDigits);
  const digitsToShow = Math.min(safeVisibleDigits, clean.length);

  const visiblePart = digitsToShow > 0 ? clean.slice(-digitsToShow) : '';

  const maskedPart = '*'.repeat(clean.length - digitsToShow);

  return maskedPart + visiblePart;
};
